import FormControl from '@mui/material/FormControl';
import { withTheme } from '@mui/styles';
import styled from 'styled-components';

export default withTheme(styled(FormControl)`
  & .MuiSelect-select {
    font-size: 18px;
    color: ${(props: any) => props.theme.palette.primary.main};
  }
  fieldset {
    border: 1px solid ${(props: any) => props.theme.palette.primary.main};
    border-radius: 4px;
  }
`);
